// cSpell:ignore xyflow Silae SILAE
import { Handle, type NodeProps, type Node } from "@xyflow/react";
import { useTranslation } from "react-i18next";

import type { GraphNodeData, Branch } from "../utils/buildGraph";
import { useDiagramHandlePositions } from "../hooks/useDiagramHandlePositions";

interface Palette {
  border: string;
  header: string;
  bg: string;
}

const PALETTE: Record<Branch, Palette> = {
  if: {
    border: "border-emerald-800 dark:border-emerald-600",
    header:
      "bg-emerald-50 text-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-200",
    bg: "bg-emerald-50/60 dark:bg-emerald-950/30",
  },
  else: {
    border: "border-orange-400 dark:border-orange-600",
    header:
      "bg-orange-50 text-orange-800 dark:bg-orange-950/60 dark:text-orange-200",
    bg: "bg-orange-50/60 dark:bg-orange-950/30",
  },
  main: {
    border: "border-sky-400 dark:border-sky-600",
    header: "bg-sky-50 text-sky-800 dark:bg-sky-950/60 dark:text-sky-200",
    bg: "bg-sky-50/60 dark:bg-sky-950/30",
  },
};

export function BranchGroupNode({ data }: NodeProps<Node<GraphNodeData>>) {
  const { t } = useTranslation();
  const { target } = useDiagramHandlePositions();
  const branch: Branch = data.branch ?? "main";
  const p = PALETTE[branch];
  const label = t(
    (data.branchGroupLabelKey as string) ??
      "step5Validation.branchGroup.mainLabel",
  );

  return (
    <>
      <Handle
        type="target"
        position={target}
        className="opacity-0 pointer-events-none"
      />
      <div
        className={[
          "relative w-full h-full rounded-xl border-2 border-dashed",
          p.border,
          p.bg,
        ].join(" ")}
      >
        <div
          className={[
            "absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap px-2 py-0.5",
            "text-[16px] font-semibold rounded border",
            "shadow-sm",
            p.header,
            p.border,
          ].join(" ")}
        >
          {label}
        </div>
      </div>
    </>
  );
}
